<template>
  <div>
    <h4>Niveles</h4>
    <router-link to="/admin/niveles/clases1">
    <button type="button" class="btn btn-primary mr-2 mb-2">Listados para coordinación</button>
    </router-link>
    <router-link to="/admin/niveles/clases2">
    <button type="button" class="btn btn-primary mr-2 mb-2">Listados para profesores</button>
    </router-link>
    <router-link to="/admin/niveles/cambio">
    <button type="button" class="btn btn-primary mr-2 mb-2">Cambio masivo de niveles</button>
    </router-link>
  </div>
</template>

<script>

export default {
	name: 'AdminNiveles',
}
</script>
